import request from '@/utils/request';

export  async function saveDingding(payload) {
  return request(`/iwms-account/account/dingding`, {
    method: 'POST',
    body: payload,
  });
}

export  async function modify(payload) {
  return request(`/iwms-account/account/dingding/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function query(payload){
  return request(`/iwms-account/account/dingding/query?companyUuid=${payload.companyUuid}&name=${payload.name}`)
}

export async function send(payload){
  return request(`/iwms-account/account/dingding/send?uuid=${payload.uuid}`)
}
